var _path, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _path2, _circle9, _circle0, _circle1, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _path3, _rect8, _rect9, _rect0, _rect1, _rect10, _circle10, _circle11, _path4, _circle12, _path5, _path6;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGroupStatsNew(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 350,
    viewBox: "0 0 350 350",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M55.125 72L107.125 13L160.625 72",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 55.625,
    cy: 69.5,
    r: 36.5,
    fill: "#C4C4C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.625,
    cy: 68.5,
    r: 27.5,
    fill: "#C4C4C4"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.125,
    cy: 207,
    r: 101,
    fill: "#C4C4C4"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.125,
    cy: 207,
    r: 100,
    stroke: "#192657",
    strokeWidth: 2
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.125,
    cy: 207,
    r: 60,
    fill: "#528FF5"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 129.125,
    cy: 207,
    r: 59,
    stroke: "#192657",
    strokeWidth: 2
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 119.125,
    cy: 207,
    r: 37,
    fill: "#F58120"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 130.125,
    cy: 207,
    r: 36,
    stroke: "#192657",
    strokeWidth: 2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M280.125 182.5L243.125 271L331.625 244",
    stroke: "#192657",
    strokeWidth: 2
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 278.125,
    cy: 185,
    r: 15,
    fill: "#192657"
  })), _circle0 || (_circle0 = /*#__PURE__*/React.createElement("circle", {
    cx: 332.125,
    cy: 244,
    r: 15,
    fill: "#F58120"
  })), _circle1 || (_circle1 = /*#__PURE__*/React.createElement("circle", {
    cx: 245.125,
    cy: 268,
    r: 15,
    fill: "#528FF5"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 245.125,
    y: 124,
    width: 33,
    height: 3,
    rx: 1.5,
    fill: "#1E334E"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 263.125,
    y: 109,
    width: 32,
    height: 3,
    rx: 1.5,
    transform: "rotate(90 263.125 109)",
    fill: "#1E334E"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 189,
    y: 328,
    width: 10,
    height: 10,
    fill: "#192657"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 219,
    y: 328,
    width: 10,
    height: 10,
    fill: "#192657"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 249,
    y: 328,
    width: 10,
    height: 10,
    fill: "#192657"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 279,
    y: 328,
    width: 10,
    height: 10,
    fill: "#192657"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 309,
    y: 328,
    width: 10,
    height: 10,
    fill: "#192657"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M154.755 240.647L155.052 241.714L156.083 241.311C157.093 240.916 158.179 240.689 159.318 240.689C164.127 240.689 167.996 244.493 167.996 249.111V291.815C167.996 295.13 166.82 298.389 164.688 300.986L157.443 309.808C155.926 311.653 155.093 313.969 155.093 316.332V326.629H105.48V316.332C105.48 313.968 104.646 311.656 103.13 309.809L103.13 309.808L95.1524 300.1L95.1521 300.1C93.5498 298.152 92.4811 295.809 92.0556 293.339L86.2503 259.444C86.2502 259.443 86.25 259.442 86.2499 259.441C86.168 258.945 86.125 258.451 86.125 257.965V255.958C86.125 251.03 90.2549 246.97 95.3863 246.97C99.884 246.97 103.698 250.096 104.494 254.36L104.494 254.361L108.742 277.103L108.742 277.104C108.949 278.199 109.481 279.161 110.224 279.903L111.931 281.609V279.196V234.385V222.861V211.422C111.931 206.805 115.8 203 120.609 203C125.417 203 129.286 206.805 129.286 211.422V222.858V227.704V229.11L130.614 228.648C131.545 228.325 132.511 228.126 133.512 228.126C137.521 228.126 140.858 230.792 141.852 234.366L142.148 235.433L143.18 235.03C144.189 234.635 145.276 234.407 146.415 234.407C150.424 234.407 153.762 237.073 154.755 240.647Z",
    fill: "#192657",
    stroke: "white",
    strokeWidth: 2
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 119.125,
    y: 160,
    width: 4,
    height: 33,
    rx: 2,
    fill: "white"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 132.887,
    y: 161.896,
    width: 4,
    height: 33,
    rx: 2,
    transform: "rotate(9.53178 132.887 161.896)",
    fill: "white"
  })), _rect0 || (_rect0 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 33,
    rx: 2,
    transform: "matrix(-0.986194 0.165595 0.165595 0.986194 109.367 161.896)",
    fill: "white"
  })), _rect1 || (_rect1 = /*#__PURE__*/React.createElement("rect", {
    width: 4,
    height: 33,
    rx: 2,
    transform: "matrix(-0.923391 0.383862 0.383862 0.923391 96.1211 166.496)",
    fill: "white"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 145.844,
    y: 167.096,
    width: 4,
    height: 33,
    rx: 2,
    transform: "rotate(22.5731 145.844 167.096)",
    fill: "white"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 106.625,
    cy: 13.5,
    r: 6.5,
    fill: "#F58120"
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 56.1254,
    cy: 60.1113,
    r: 9.77778,
    fill: "#192657"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M40.125 83.1113C40.125 74.8271 46.8407 68.1113 55.125 68.1113H57.125C65.4093 68.1113 72.125 74.8271 72.125 83.1113V87.6669H40.125V83.1113Z",
    fill: "#192657"
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 156.125,
    cy: 60.7222,
    r: 6.72222,
    fill: "#528FF5"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M145.125 77.2222C145.125 71.147 150.05 66.2222 156.125 66.2222C162.2 66.2222 167.125 71.147 167.125 77.2222V79.6666H145.125V77.2222Z",
    fill: "#528FF5"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M268.498 73.4999C196.498 49.3332 51.0983 22.2999 45.4983 107.5C38.4983 214 -29.5017 351.5 147.498 339.5C324.498 327.5 192.5 265 182 177.5C171.5 90 385.5 170 324 283.5C274.8 374.3 221.167 324.667 200.5 288.5",
    stroke: "black",
    strokeDasharray: "2 2 2 2"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGroupStatsNew);
export default __webpack_public_path__ + "static/media/GroupStatsNew.06b41820240f7ae6393193f5f33f3e86.svg";
export { ForwardRef as ReactComponent };